import apiClient from './apiClient';

export interface PaymentCatalogCountry {
  code: string;
  name: string;
  currency: string;
  locale: string;
  phone_prefix: string;
  enabled: boolean;
}

export interface PaymentCatalogMethod {
  code: string;
  label: string;
}

export interface PaymentCatalogProvider {
  name: string;
  display_name: string;
  methods: PaymentCatalogMethod[];
}

export interface LocalizedAppPlan {
  id: string;
  slug: string;
  name: string;
  description?: string;
  price: number;
  currency: string;
  duration_days: number;
  features: string[] | unknown;
  is_popular: boolean;
}

export interface PaymentCatalog {
  country: PaymentCatalogCountry;
  requested_country: string;
  fallback: boolean;
  providers: PaymentCatalogProvider[];
  app_plans: LocalizedAppPlan[];
}

export async function getPaymentCatalog(country?: string): Promise<PaymentCatalog> {
  const qs = country ? `?country=${encodeURIComponent(country)}` : '';
  const { data } = await apiClient.get<PaymentCatalog>(`/public/payments/catalog${qs}`, {
    skipAuth: true,
  });
  return data;
}
